var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import createStore from './../../store/store';
import { optionsReducer } from './../../store/reducer';
import { ChartContext } from '../../ChartContext';
/**
 * @hidden
 */
var ConfigurationComponent = /** @class */ (function (_super) {
    __extends(ConfigurationComponent, _super);
    function ConfigurationComponent(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.optionsStore = context.optionsStore;
        _this.childStore = createStore(optionsReducer);
        return _this;
    }
    ConfigurationComponent.prototype.render = function () {
        var _this = this;
        var children = this.props.children;
        return children !== undefined ? React.Children.map(children, function (child) {
            if (React.isValidElement(child)) {
                return _this.renderChildren(child);
            }
            return child;
        }) : null;
    };
    ConfigurationComponent.prototype.componentDidMount = function () {
        this.dispatch();
    };
    ConfigurationComponent.prototype.componentDidUpdate = function () {
        this.dispatch();
    };
    ConfigurationComponent.prototype.dispatch = function () {
        var _a = this.props, _chartKey = _a._chartKey, _chartCollectionIdxKey = _a._chartCollectionIdxKey, _parentStore = _a._parentStore, children = _a.children, options = __rest(_a, ["_chartKey", "_chartCollectionIdxKey", "_parentStore", "children"]);
        var store = _parentStore || this.optionsStore;
        store.dispatch({
            chartKey: _chartKey,
            chartCollectionIdxKey: _chartCollectionIdxKey,
            payload: Object.assign({}, options, this.childStore.getState())
        });
    };
    ConfigurationComponent.prototype.renderChildren = function (child) {
        var children = child.props.children;
        var configurationItemProps = __assign({}, child.props, { _parentStore: this.childStore });
        return React.cloneElement(child, configurationItemProps, children);
    };
    ConfigurationComponent.contextType = ChartContext;
    return ConfigurationComponent;
}(React.Component));
export default ConfigurationComponent;
//# sourceMappingURL=ConfigurationComponent.js.map